// Route matchers that define which quoting-ui flows are in scope for passive tracking.
const QUOTE_TRACKING_ROUTE_PATTERNS: RegExp[] = [/^\/resume(?:[-/].*)?$/];

export const isQuoteTrackingRoute = (pathname: string): boolean => {
  return QUOTE_TRACKING_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname));
};
